import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import useInterval from '../useInterval/useInterval.js';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const useFromNow = (timestamp, format = "static", intervalTime = 1000) => {
    const [formattedDate, setFormattedDate] = useState("");
    const getCustomRelativeTime = (timestamp, format) => {
        const diffInSeconds = dayjs().diff(dayjs(timestamp), "second");
        const d = dayjs.duration(diffInSeconds, "seconds");
        const years = d.years();
        const months = d.months();
        const days = d.days();
        const hours = d.hours();
        const minutes = d.minutes();
        const seconds = d.seconds();
        if (format === "exactFixed") {
            return `${years}y ${months}mo ${days}d ${hours}h ${minutes}m ${seconds}s`;
        }
        else if (format === "exactDynamic") {
            let result = "";
            if (years > 0) {
                result += `${years}y `;
            }
            if (months > 0 || years > 0) {
                result += `${months}mo `;
            }
            if (days > 0 || months > 0 || years > 0) {
                result += `${days}d `;
            }
            if (hours > 0 || days > 0 || months > 0 || years > 0) {
                result += `${hours}h `;
            }
            if (minutes > 0 || hours > 0 || days > 0 || months > 0 || years > 0) {
                result += `${minutes}m `;
            }
            result += `${seconds}s`;
            return result.trim();
        }
        else {
            //static
            if (diffInSeconds < 60) {
                return `just now`;
            }
            else {
                return dayjs(timestamp).fromNow();
            }
        }
    };
    const updateDate = () => {
        setFormattedDate(getCustomRelativeTime(timestamp, format));
    };
    useEffect(updateDate, [timestamp, format]);
    useInterval(updateDate, intervalTime);
    return formattedDate;
};

export { useFromNow as default };
//# sourceMappingURL=useFromNow.js.map
